@if (isLoadingProductListPage) {
<div class="loading-container">
  <mat-spinner [diameter]="72"></mat-spinner>
</div>
} @else {
<mat-sidenav-container class="product-list-wrapper">
  <mat-sidenav #sidenav (closed)="onClose()" [mode]="mode.value" [(opened)]="sideNavOpened">
    <div class="close-icon">
      <mat-icon (click)="sidenav.close()" class="material-icons-sharp md-12">clear</mat-icon>
    </div>
    @if (model$ | async; as model) {
    <div class="side-nav-sorting">
      @if (model.products.length > 0) {
      <div class="container">
        <div class="row">
          <div class="col-12 sort-label">
            {{ 'product.productSorting.title' | cxTranslate }}
          </div>
          <div class="col-12 form-wrapper">
            <div class="form-group cx-sort-dropdown">
              <app-product-sorting
                [sortOptions]="model.sorts"
                (sortListEvent)="sortList($event)"
                [selectedOption]="model.pagination.sort"
                [sidenav]="'true'"
                placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
              ></app-product-sorting>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
    <app-product-refinement [sidenavopen]="isSideNaveOpen" [sidenav]="'true'"></app-product-refinement>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (model$ | async; as model) {
    <div class="cx-page">
      @if (isSearchPage) {
      <section class="search-results-section">
        <app-search-results-info [count]="model.pagination.totalResults"></app-search-results-info>
        <app-spelling-suggestion [didYouMean]="model.spellingSuggestion"></app-spelling-suggestion>
      </section>
      }
      <section class="cx-page-section">
        <div class="container-fluid">
          <div class="row no-gutters">
            @if (viewMode$ | async; as viewMode) {
            <div class="col-12 col-lg-12">
              <button class="btn-sort-filter" (click)="toggleSidenav()">
                <mat-icon class="light" svgIcon="filter"></mat-icon>
                {{ 'product.productSorting.sortFilter' | cxTranslate }}
              </button>
              @if (model.products.length > 0) {
              <div class="cx-sorting top">
                <div class="row">
                  <div class="col-12 col-lg-4 mr-auto">
                    <div class="form-group cx-sort-dropdown">
                      <app-product-sorting
                        [sortOptions]="model.sorts"
                        (sortListEvent)="sortList($event)"
                        [selectedOption]="model.pagination.sort"
                        placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
                      ></app-product-sorting>
                    </div>
                  </div>
                  @if (!isInfiniteScroll) {
                  <div class="col-auto">
                    <div class="cx-pagination" [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                      <cx-pagination
                        [pagination]="model.pagination"
                        queryParam="currentPage"
                        [defaultPage]="0"
                      ></cx-pagination>
                    </div>
                  </div>
                  }
                  <div class="col-auto ml-auto ml-lg-0 product-view-wrapper">
                    <app-product-view
                      class="product-view"
                      (modeChange)="setViewMode($event)"
                      [mode]="ViewModes.Grid"
                    ></app-product-view>
                    <app-product-view
                      class="product-view"
                      (modeChange)="setViewMode($event)"
                      [mode]="ViewModes.List"
                    ></app-product-view>
                  </div>
                </div>
              </div>
              }
              <div
                class="cx-product-container"
                [ngClass]="{
                  'popup-enabled': isPlpPopupEnabled
                }"
              >
                <!-- IF EMPTY PRODUCTS -->
                @if (model.products.length < 1) {
                <label>{{ 'product.productList.noProducts' | cxTranslate }}</label>
                }
                <!-- Product list when using pagination -->
                @if (!isInfiniteScroll) { @if (viewMode === ViewModes.Grid) {
                <div id="app-product-grid-item-main-wrapper">
                  @for (product of productListResults; track product; let i = $index) {
                  <app-product-grid-item
                    [product]="product"
                    [dealerPrices]="dealerPrices"
                    [isSearchPage]="isSearchPage"
                    [position]="i + 1"
                    [hasDealerPrice]="hasDealerPrice"
                    class="col-12 col-sm-6 col-md-4"
                  ></app-product-grid-item>
                  }
                </div>
                } @if (viewMode === ViewModes.List && model.products.length > 0) { @for (product of productListResults;
                track product; let i = $index) {
                <app-product-list-item
                  [product]="product"
                  [dealerPrices]="dealerPrices"
                  [isSearchPage]="isSearchPage"
                  [position]="i + 1"
                  [hasDealerPrice]="hasDealerPrice"
                  [basepriceHidden]="basepriceHidden"
                  class="app-product-search-list"
                ></app-product-list-item>
                } } } @else {
                <app-shimano-product-scroll
                  [scrollConfig]="scrollConfig"
                  [model]="model"
                  [inputViewMode]="viewMode"
                  [productListResults]="productListResults"
                  [cachedlastPage]="cachedLastPage"
                  [isCachedLastPage]="cachedLastPage === model.pagination.totalPages - 1"
                ></app-shimano-product-scroll>
                }
                <!-- Product list when using infinite scroll -->
              </div>
              <div class="cx-sorting bottom">
                <div class="row">
                  <label class="form-group cx-sort-dropdown col-12 col-lg-4 mr-auto"> </label>
                  @if (!isInfiniteScroll) {
                  <div class="col-auto" [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                    <div class="cx-pagination">
                      <cx-pagination
                        [pagination]="model.pagination"
                        queryParam="currentPage"
                        [defaultPage]="0"
                      ></cx-pagination>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </section>
    </div>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
}
